const images = {
  documents: {
    passport: require("./all_passaport.jpeg"),

    CONationalFront: require("./co_national_front.jpeg"),
    CONationalBack: require("./co_national_back.jpeg"),

    COForeignFront: require("./co_foreign_front.jpeg"),
    COForeignBack: require("./co_foreign_back.jpeg"),

    COPep: require("./co_pep_front.jpeg"),

    MXNationalFront: require("./mx_ine_ife_front.jpeg"),
    MXNationalBack: require("./mx_ine_ife_back.jpeg"),

    MXForeignFront: require("./mx_fm3_front.jpeg"),
    MXForeignBack: require("./mx_fm3_back.jpeg"),

    BRNationalFront: require("./br_rg_front.jpeg"),
    BRNationalBack: require("./br_rg_back.jpeg"),

    BRDriversLicenseFront: require("./br_cnh_front.jpeg"),
    BRDriversLicenseBack: require("./br_cnh_back.jpeg"),

    CLNationalFront: require("./cl_national_front.png"),
    CLNationalBack: require("./cl_national_back.png"),

    selfie: require("./selfie_face_photo_validation.jpeg"),
  },
};

export default images;
